import { AppState } from 'src/app/store'

export const salesListSelector = (state: AppState) => state.sales.list
export const salesFilteredSelector = (state: AppState) => state.sales.list.filtered
export const selectedSalesSelector = (state: AppState) => state.sales.list.selected
export const oldSaleListSelector = (state: AppState) => state.sales.list.sales
export const saleFilterTextSelector = (state: AppState) => state.sales.list.filterText
export const saleDetailsSelector = (state: AppState) => state.sales.getOne
export const sendSaleDocumentSelector = (state: AppState) => state.sales.sendDocument
export const deleteSaleDocumentSelector = (state: AppState) => state.sales.deleteDocument
